// src/components/InfoPane.js
import React from 'react';

function InfoPane({ info }) {
  if (!info || !info.label) {
    return (
      <div className="h-24 mb-4 p-3 bg-gray-50 rounded-lg text-sm text-gray-400 italic flex items-center justify-center shadow-inner">
        Hover over an option for details.
      </div>
    );
  }

  return (
    <div className="h-auto min-h-[6rem] mb-4 p-4 bg-indigo-50 rounded-lg border border-indigo-200 shadow-sm transition-all duration-300">
      <div className="flex items-start gap-3">
        {info.icon && info.itemType !== 'color' && info.itemType !== 'fabric' && (
          <img src={info.icon} alt={info.label} className="w-10 h-10 object-contain flex-shrink-0" />
        )}
        {info.itemType === 'color' && info.swatch && (
          <div
            className={`w-10 h-10 rounded-full flex-shrink-0 shadow-sm ${info.border ? 'border-2 border-gray-300' : ''}`}
            style={{ backgroundColor: info.swatch }}
          ></div>
        )}
         {info.itemType === 'fabric' && info.icon && (
          <img src={info.icon} alt={info.label} className="w-10 h-10 object-cover rounded-md flex-shrink-0 shadow-sm" />
        )}
        <div className="flex-grow">
          <h4 className="font-semibold text-indigo-700 text-md mb-0.5">{info.label}</h4>
          <p className="text-xs text-gray-600 leading-relaxed">{info.description || 'Select an option to learn more.'}</p>
        </div>
      </div>
    </div>
  );
}

export default InfoPane;